module.exports = "<h2>Messages</h2>\n<ul>\n  <li *ngFor=\"let message of messages\">\n    {{ message.msg }}\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/inbox.html
// module id = ./src/app/Templates/inbox.html
// module chunks = main